import { render, staticRenderFns } from "./TiketDetail.vue?vue&type=template&id=2acf4316&"
import script from "./TiketDetail.vue?vue&type=script&lang=js&"
export * from "./TiketDetail.vue?vue&type=script&lang=js&"
import style0 from "./TiketDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports